<template>
  <a-modal
    ref="createModal"
    title="新增类别集"
    :width="800"
    :maskClosable="false"
    :visible="visible"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 类别集名称 -->
      <span slot="categorySetNameTitle">
        <i class="toRequired">*</i>类别集名称
      </span>
      <template slot="categorySetCode" slot-scope="text, record">
        <global-select
          :value.sync="record.categorySetCode"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'MDM_CATEGORY_SETS' }"
          :allowClear="false"
          @change="(val, list) => categorySetCodeChange(val, list, record)"
        />
      </template>

      <template slot="categorySetDesc" slot-scope="text, record">
        <a-input v-model="record.categorySetDesc" />
      </template>
      <!-- 允许存在多个物料类别分配 -->
      <span slot="multItemCatAssignFlagTitle">
        <i class="toRequired">*</i>允许存在多个物料类别分配
      </span>
      <template slot="multItemCatAssignFlag" slot-scope="text, record">
        <a-switch :checked="record.multItemCatAssignFlag === 'Y'" @change="switchOnChange(record)" />
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemCategorySetAdd } from '@/api/mdm/matter/material-category'
// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '类别集名称',
          width: 150,
          dataIndex: 'categorySetCode',
          scopedSlots: { customRender: 'categorySetCode', title: "categorySetNameTitle" }
        },
        {
          title: '类别集说明',
          width: 150,
          dataIndex: 'categorySetDesc',
          scopedSlots: { customRender: 'categorySetDesc' }
        },
        {
          // title: '允许存在多个物料类别分配',
          width: 160,
          dataIndex: 'multItemCatAssignFlag',
          scopedSlots: { customRender: 'multItemCatAssignFlag', title: "multItemCatAssignFlagTitle" }
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 类别集名称
    categorySetCodeChange (val, list, record) {
      record.categorySetDesc = this.$getFlagName(list, val, "lookupCode", "remark")
      record.categorySetName = this.$getFlagName(list, val, "lookupCode", "lookupValue")
    },
    // 允许存在多个物料类别分配
    switchOnChange (record) {
      record.multItemCatAssignFlag = record.multItemCatAssignFlag === "Y" ? "N" : "Y"
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        organizationId: this.organizationCodeOrigin,
        categorySetCode: "",
        categorySetDesc: "",
        multItemCatAssignFlag: "N",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].categorySetCode) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiItemCategorySetAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
